export const positionState = {
  eyesClosedStart: null,
  multipleFaceStart: null,
  noFaceStart: null,
};

export const positionGetters = {};

export const positionMutations = {
  SET_EYES_CLOSED_START(state, val) {
    state.eyesClosedStart = val;
  },
  SET_MULTIPLE_FACE_START(state, val) {
    state.multipleFaceStart = val;
  },
  SET_NO_FACE_START(state, val) {
    state.noFaceStart = val;
  },
};

export const positionActions = {
  detectEyesClosed({ state, commit, dispatch }, landmarks) {
    const LEFT_EYE = [33, 160, 158, 133, 153, 144];
    const RIGHT_EYE = [362, 385, 387, 263, 373, 380];

    const getEAR = (indices) => {
      const dist = (a, b) =>
        Math.hypot(
          landmarks[a].x - landmarks[b].x,
          landmarks[a].y - landmarks[b].y
        );
      return (
        (dist(indices[1], indices[5]) + dist(indices[2], indices[4])) /
        (2.0 * dist(indices[0], indices[3]))
      );
    };

    const avg = (getEAR(LEFT_EYE) + getEAR(RIGHT_EYE)) / 2;

    if (avg < 0.2) {
      if (!state.eyesClosedStart) {
        commit("SET_EYES_CLOSED_START", Date.now());
      } else if (Date.now() - state.eyesClosedStart > 2000) {
        dispatch("triggerViolation", {
          type: "EYES_CLOSED",
          reason: "Eyes closed too long",
        });
      }
    } else {
      commit("SET_EYES_CLOSED_START", null);
    }
  },
};
